<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2576_578)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M4 2.64463C3.26362 2.64463 2.66667 3.23665 2.66667 3.96695V19.8348C2.66667 20.565 3.26362 21.1571 4 21.1571H20C20.7364 21.1571 21.3333 20.565 21.3333 19.8348V3.96695C21.3333 3.23665 20.7364 2.64463 20 2.64463H4ZM0 3.96695C0 1.77606 1.79086 0 4 0H20C22.2091 0 24 1.77606 24 3.96695V19.8348C24 22.0256 22.2091 23.8017 20 23.8017H4C1.79086 23.8017 0 22.0256 0 19.8348V3.96695Z" fill="#5B6770"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M8.00014 0C8.73652 0 9.33348 0.592021 9.33348 1.32232V22.4794C9.33348 23.2097 8.73652 23.8017 8.00014 23.8017C7.26376 23.8017 6.66681 23.2097 6.66681 22.4794V1.32232C6.66681 0.592021 7.26376 0 8.00014 0Z" fill="#5B6770"/>
</g>
<defs>
<clipPath id="clip0_2576_578">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
